

















import { Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import CounterList from '@/components/counters/CounterList.vue';
import { User } from '@/modules/backend/Entities/User';
import { Account } from '@/modules/backend/Entities/Account';
import Mixin from '@/mixins/base';

const AuthModule = namespace('app/auth');

@Component({
  mixins: [Mixin],
  components: {
    'counter-list': CounterList
  }
})
export default class AccountSingle extends Mixins(Mixin) {
  @AuthModule.Getter('Info')
  private readonly authInfo!: User;

  private get authAccount(): Account {
    return this.authInfo.getAccount();
  }
}
